import { IClearSessionPayload, ICreateSessionPayload } from 'shared/models/Upgaming'

import { BaseHttpService } from '../BaseHttpService'
import { QueryTypes } from '../data'
import { UpgamingConverter } from './UpgamingConverter'

class UpgamingApi extends BaseHttpService {
  private converter

  constructor(baseUrl: string) {
    super(baseUrl)
    this.baseUrl = `${baseUrl}/api/integrations/upgaming`
    this.converter = new UpgamingConverter()
  }

  createSession = (payload: ICreateSessionPayload) =>
    this.sendQuery({
      type: QueryTypes.POST,
      url: `${this.baseUrl}/login`,
      data: payload,
      converterSuccess: this.converter.convertSessionUrl,
    })

  createGuestSession = (payload: ICreateSessionPayload) =>
    this.sendQuery({
      type: QueryTypes.POST,
      url: `${this.baseUrl}/login/demo`,
      data: payload,
      converterSuccess: this.converter.convertSessionUrl,
    })

  clearSession = (payload: IClearSessionPayload) =>
    this.sendQuery({
      type: QueryTypes.POST,
      url: `${this.baseUrl}/logout`,
      data: payload,
    })
}

export default UpgamingApi
